import {
  ChargeBackCard,
  ChargeBackWrapper,
  ChargeBackCardAction,
  ChargeBackCardHeader,
  ChargeDeliveryTitle,
  ChargeBackCardContent,
  ChargeBackAcceptButton,
  ChargeBackDisputeButton,
  ChargeBackCardHeaderInnerBox,
} from "components/styles/styles";
import {useContext, lazy, useMemo} from "react";
import {useSelector} from "react-redux";
import {Box, IconButton} from "@mui/material";
import ErrorModal from 'components/Modal/ErrorModal';
import Preloader from "components/Preloader/Preloader";
import {ChargeBackContext} from "context/ChargeBackContext";
import {StatusEnum} from "components/ChargeBackDispute/config";
import {useChargeBack} from "components/ChargeBackDispute/hooks/useChargeBack";
import LocalPrintshopOutlinedIcon from "@mui/icons-material/LocalPrintshopOutlined";
import ChargeBackInfoContent from 'components/ChargeBackContent/ChargeBackInfoContent';
const EmptyOrder = lazy(() => import("components/OrderDetails/EmptyOrder"));
const OrderDetailsCharges = lazy(() => import("components/OrderDetails/OrderDetailsCharges"));
const OrderDetailsModifier = lazy(() => import("components/OrderDetails/OrderDetailsModifier"));
const OrderDetailsHeader = lazy(() => import("components/OrderDetails/OrderDetailsHeader"));
const DisputeModal = lazy(() => import("components/Modal/DisputeModal"));
const ConfirmModal = lazy(() => import("components/Modal/ConfirmModal"));

const ChargeBackDispute = () => {
  const { allOrderData  } = useContext(ChargeBackContext);
  const { errorMessage, showError } = useSelector((state) => state.error);
  const {
    handlePrint,
    openDisputeModal,
    handleOpen,
    handleClose,
    selectedReason,
    handleChange,
    handleFormSubmit,
    formMethods,
    loading,
    handleStatus,
    handleStatusSwitch,
    handleAccept,
    handleCloseConfirmModal,
    handleConfirmModal,
    openConfirmModal,
    loadingButton,
  }  = useChargeBack();

  const hasValidOrderData = useMemo(() => {
    return !allOrderData.hasOwnProperty('orderData') ||
      (allOrderData.hasOwnProperty('orderData') &&
        !allOrderData.orderData.hasOwnProperty('charges'));
  }, [allOrderData]);


  if(loading) {
    return <Preloader overlay={true} />
  }
  if(!loading && Boolean(showError && errorMessage)) {
    return <ErrorModal />
  }

  let currentStatus = handleStatus(allOrderData?.status);
  return (
    <ChargeBackWrapper>
      <DisputeModal
        open={openDisputeModal}
        handleClose={handleClose}
        selectedReason={selectedReason}
        handleChange={handleChange}
        handleFormSubmit={handleFormSubmit}
        formMethods={formMethods}
        handleStatusSwitch={handleStatusSwitch}
        handleStatus={handleStatus}
        loadingButton={loadingButton}
      />
      <ConfirmModal
        handleClose={handleCloseConfirmModal}
        open={openConfirmModal}
        title={'Accept'}
        description={allOrderData?.chargeTotal}
        handleConfirmModal={handleConfirmModal}
        loadingButton={loadingButton}
      />
      <ChargeBackCard sx={{ minHeight: !hasValidOrderData ? '850px' : '810px' }}>
        <ChargeBackCardHeader>
          <ChargeBackCardHeaderInnerBox>
            <ChargeDeliveryTitle>Chargeback info</ChargeDeliveryTitle>
            <Box onClick={() => handlePrint()}>
              <IconButton disabled={false}>
                <LocalPrintshopOutlinedIcon />
              </IconButton>
            </Box>
          </ChargeBackCardHeaderInnerBox>
        </ChargeBackCardHeader>
        <ChargeBackCardContent
          sx={{ bottom: currentStatus?.type === StatusEnum.CREATED ? '82px' : '10px' }}
        >
          <Box>
            <ChargeBackInfoContent
              currentStatus={currentStatus}
              handleStatusSwitch={handleStatusSwitch}
            />
            {hasValidOrderData ? (
              <EmptyOrder />
            ) : (
              <>
                <OrderDetailsHeader />
                <OrderDetailsModifier />
                <OrderDetailsCharges currentStatus={currentStatus} />
              </>
            )}
          </Box>
        </ChargeBackCardContent>
        {currentStatus?.type === StatusEnum.CREATED && (
          <ChargeBackCardAction>
            <ChargeBackAcceptButton onClick={handleAccept}>Accept</ChargeBackAcceptButton>
            <ChargeBackDisputeButton loading={false} onClick={handleOpen}>Dispute</ChargeBackDisputeButton>
          </ChargeBackCardAction>
        )}
      </ChargeBackCard>
    </ChargeBackWrapper>
  )
};
export default ChargeBackDispute